var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 7.4c-9.2 9.2-9.2 24 0 33.2s24 9.2 33.2 0 9.2-24 0-33.2-24-9.2-33.2 0zM31.5 23c.6 0 1 .4 1 1 0 .3-.1.6-.3.7-.1.1-.4.3-.7.3H25v6.5c0 .3-.1.6-.3.7s-.4.3-.7.3c-.6 0-1-.4-1-1V25h-6.5c-.6 0-1-.4-1-1s.4-1 1-1H23v-6.5c0-.6.4-1 1-1s1 .4 1 1V23h6.5z"
  })));
};
export default SvgZoomIn;